// extracted by mini-css-extract-plugin
module.exports = {"page":"style_page__3z0B5","wrapper":"style_wrapper__39rkT","spinner":"style_spinner__2P0sc"};